<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    :before-close="handleClose"
    custom-class="custom-scrollable"
    label-position="top"
  >
    <div class="-mt-10">
      <div class="p-2 rounded-sm shadow-sm bg-root-3 font-normal w-3/4 mb-2">
        <p>Filter Options</p>
      </div>
      <!-- status -->
      <el-form
        :model="tableFormFilter"
        label-position="top"
        ref="tableFormFilter"
      >
        <el-form-item label="Status" prop="status">
          <el-radio-group v-model="tableFormFilter.status">
            <el-radio label="active">Active</el-radio>
            <el-radio label="inactive">Inactive</el-radio>
            <el-radio label="">All</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Payment Link" prop="paymentLink">
          <el-radio-group v-model="tableFormFilter.paymentLinkType">
            <el-radio label="one_time">One Time</el-radio>
            <el-radio label="recurring">Recurring</el-radio>
            <el-radio label="">All</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Date" prop="date">
          <el-radio-group v-model="tableFormFilter.date">
            <el-radio label="oldest to newest">Oldest to Newest</el-radio>
            <el-radio label="newest to oldest">Newest to Oldest</el-radio>
            <el-radio label="7 days">7 Days</el-radio>
            <el-radio label="30 days">30 Days</el-radio>
            <el-radio label="custom">Custom </el-radio>
            <el-radio label="">All</el-radio>
            <div v-if="isCustomDate" class="">
              <el-form-item label="Select start date" class="mr-2">
                <el-date-picker
                  v-model="tableFormFilter.startDate"
                  type="date"
                  placeholder="Pick a date"
                  format="dd/MM/yyyy"
                  value-format="dd/MM/yyyy"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="Select end date">
                <el-date-picker
                  v-model="tableFormFilter.endDate"
                  type="date"
                  placeholder="Pick a date"
                  format="dd/MM/yyyy"
                  value-format="dd/MM/yyyy"
                >
                </el-date-picker>
              </el-form-item>
            </div>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <o-button
            @click="submitForm('tableFormFilter')"
            class="bg-primary text-white w-full rounded-3xl outline-none border-none mt-7"
            >Apply</o-button
          >
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data () {
    return {
      breakpoints,
      tableFormFilter: {
        status: '',
        paymentLinkType: '',
        date: '',
        startDate: '',
        endDate: ''
      }
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDialog')
    },
    submitForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.$emit('filterParams', this.tableFormFilter)
          this.$store.dispatch(
            'paymentLink/setPaymentLinkFilter',
            this.tableFormFilter
          )
          this.handleClose()
        } else {
          this.$notify({
            showClose: true,
            message: 'Please fill all inputs correctly',
            type: 'error'
          })
        }
      })
    }
  },
  computed: {
    paymentLinkFilter () {
      return this.$store.state.paymentLink.paymentLinkFilter
    },
    isCustomDate () {
      return this.tableFormFilter.date === 'custom'
    },
    modalWidth () {
      return breakpoints.lgAndUp ? '20%' : breakpoints.mdAndUp ? '40%' : '70%'
    }
  },
  mounted () {
    if (this.paymentLinkFilter) {
      this.tableFormFilter = { ...this.paymentLinkFilter }
    }
  }
}
</script>

<style scoped>
>>> .el-radio-group {
  display: flex;
  flex-direction: column;
}
>>> .el-radio {
  margin-bottom: 0.8rem;
}
>>> .el-radio__label {
  font-size: 13px;
}
>>> .el-radio__inner {
  height: 18px;
  width: 18px;
}
>>> .el-form-item {
  margin-bottom: -0.5rem;
}
>>> .el-form-item__label {
  font-size: 0.8rem;
  margin-bottom: -0.35rem;
  padding: 0;
}
</style>
